import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-placeholder',
  standalone: false,
  templateUrl: './placeholder.component.html',
  styleUrl: './placeholder.component.scss'
})
export class PlaceholderComponent {

  @Input('message') message?: string;
  @Input('noStarImage') noStarImage?: boolean;

  constructor() { }

}
